import { render } from "./SelectForm.vue?vue&type=template&id=0e0a9392"
import script from "./SelectForm.vue?vue&type=script&lang=ts"
export * from "./SelectForm.vue?vue&type=script&lang=ts"
script.render = render

export default script